import axios from 'axios'
import router from '../../router'

// Request interceptor
axios.interceptors.request.use(
  function (config) {
    // URLs that don't need authentication token
    const tobeInoredUrl = [
      '/nexacon-auth/login/',
      '/nexacon-auth/register/',
      '/nexacon-auth/refresh/',
      '/nexacon-auth/logout/',
      '/nexacon-auth/activate-account/',
      '/nexacon-auth/resend-otp/',
      '/nexacon-auth/reactivate-account/',
      '/nexacon-auth/reset-password/',
      '/nexacon-auth/confirm-reset-password/',
    ]
    const isToBeIgnored = tobeInoredUrl.some((url) => config.url?.includes(url))

    // Add authentication token if not ignored
    if (!isToBeIgnored) {
      const accessTokenStr = sessionStorage.getItem('access')
      if (accessTokenStr) {
        try {
          const token = JSON.parse(accessTokenStr)
          config.headers.Authorization = `Bearer ${token}`
        } catch (parseError) {
          console.warn('Failed to parse access token:', parseError)
          // Continue without adding the token if parsing fails
        }
      }
    }

    // URLs that need API keys
    const urlsNeedingApiKeys = [
      // Device related endpoints
      'iot-core/device-types',
      'iot-core/device-categories',
      'iot-core/device-products',
      'iot-core/device-registration',
      'iot-core/devices',
      'iot-core/device-topics',
      'iot-core/control',
      'iot-core/device-topic-logs',
      'iot-core/assets',

      // Dashboard related endpoints
      'reports/dashboard/device-stats',
      'reports/dashboard/device-categories',
      'reports/dashboard/api-usage',
      'reports/dashboard/data-usage',
      'reports/dashboard/recent-activities',
      'reports/dashboard/alerts',

      // Auth and user related endpoints
      'nexacon-auth/client-users',
      'nexacon-auth/user-profile',
      'nexacon-auth/deactivate-account',
      'nexacon-auth/apps',
      'nexacon-auth/nxm-token',
      'nexacon-auth/firebase-credentials',

      // Service related endpoints
      'services/services',
      'services/subscriptions',
      'services/active-subscriptions',
      'services/payments',
      'services/fx',

      // Common endpoints
      'common/api-logs/my-logs',

      // NX Group chat endpoints
      'nx/groups',
    ]

    // Check if current URL needs API keys
    const needsApiKeys = urlsNeedingApiKeys.some((url) => config.url?.includes(url))

    // Add API authentication headers only to specific URLs
    if (needsApiKeys) {
      config.headers['x-Api-key'] = import.meta.env.VITE_APP_API_KEY
      config.headers['x-Secret-key'] = import.meta.env.VITE_APP_SECRET_KEY
    }

    return config
  },
  function (error) {
    console.log(error)
    return Promise.reject(error)
  },
)

// Response interceptor
axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    if (error.response && error.response.status === 401) {
      // Avoid redirecting if already on login page
      if (router.currentRoute.value.path !== '/auth/login') {
        router.push('/auth/login')
      }
    }
    return Promise.reject(error)
  },
)
